import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sunrise, Sunset, Mountain, Sparkles } from "lucide-react";

export default function BugunKapadokyaWidget() {
  const [data, setData] = useState(null);
  useEffect(() => { (async () => {
    try { const { data } = await api.get("/today"); setData(data); } catch {}
  })(); }, []);
  if (!data) return null;

  const toneColor = {
    ok: "text-emerald-700 bg-emerald-50 border-emerald-200",
    warn: "text-amber-700 bg-amber-50 border-amber-200",
    bad: "text-red-700 bg-red-50 border-red-200",
  }[data.balloon?.tone] || "text-cc-sepia bg-cc-bg/40 border-cc-border";

  return (
    <section className="bg-cc-dark text-cc-bg py-8 md:py-10 border-y border-cc-bg/15" data-testid="bugun-kapadokya">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-12 items-center gap-6 md:gap-10">
          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.32em] uppercase text-cc-sepia mb-2 flex items-center gap-2">
              <Sparkles size={12} /> Bugün Kapadokya
            </div>
            <div className="font-serif text-2xl md:text-3xl leading-none">{data.date_tr}</div>
            <div className="text-xs text-cc-bg/55 mt-1">{data.weekday_tr} · {data.location}</div>
          </div>

          <div className="md:col-span-2 border-l border-cc-bg/15 pl-6">
            <Sunrise size={16} className="text-cc-sepia mb-1.5" />
            <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/55">Gün Doğumu</div>
            <div className="font-serif text-xl text-cc-bg">{data.sunrise}</div>
          </div>

          <div className="md:col-span-2 border-l border-cc-bg/15 pl-6">
            <Sunset size={16} className="text-cc-sepia mb-1.5" />
            <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/55">Gün Batımı</div>
            <div className="font-serif text-xl text-cc-bg">{data.sunset}</div>
          </div>

          <div className="md:col-span-2 border-l border-cc-bg/15 pl-6">
            <Mountain size={16} className="text-cc-sepia mb-1.5" />
            <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/55">Mevsim</div>
            <div className="font-serif text-xl text-cc-bg">{data.season}</div>
          </div>

          <div className="md:col-span-3 border-l border-cc-bg/15 pl-6">
            <div className="text-[10px] tracking-[0.22em] uppercase text-cc-bg/55 mb-1.5">Balon Uçuş Durumu</div>
            <div className={`inline-block px-3 py-1.5 text-xs tracking-wider border ${toneColor}`} data-testid="balloon-status">
              {data.balloon?.label || "—"}
            </div>
            {data.balloon?.note && <div className="text-[11px] text-cc-bg/55 mt-2">{data.balloon.note}</div>}
          </div>
        </div>
        <div className="mt-5 text-xs text-cc-bg/55 italic">{data.season_note}</div>
      </div>
    </section>
  );
}
